export function nextItem (currentIndex, keys, savedIndicators) {
  let nextIndicator = savedIndicators[0];

  let nextKey;
  if (currentIndex === -1 || currentIndex >= keys.length - 1) {
    currentIndex = 0;
    nextKey = keys[0];
    nextIndicator = savedIndicators.find(indicator => indicator.id === nextKey);
  } else {
    nextKey = keys[currentIndex + 1];
    nextIndicator = savedIndicators.find(indicator => indicator.id === nextKey);
  }
  if (!nextIndicator.tipo) {
    this.$router.push({
      name: 'detalle_indicador',
      params: { idIndicador: nextKey }
    });
  } else {
    this.$router.push({
      name: 'detalle_indicador_aue',
      params: { idCiudadIndicadorAUE: nextKey, tipo: nextIndicator.tipo, nameLink: 'Observatorio de indicadores', link: '/indices-tematicos' }
    });
  }
};

export function initLoop (idIndicador, indicatorsForLoop, loopTime) {
  let timeOutId = '';
  if (!indicatorsForLoop || indicatorsForLoop.length <= 0) {
    return;
  }
  console.log(indicatorsForLoop);
  const savedIndicators = indicatorsForLoop.map((item) => {
    return {
      [item.id]: loopTime
    };
  });

  const currentId = idIndicador;
  const keys = savedIndicators.map((obj) => Object.keys(obj)[0]);

  const currentIndex = keys.indexOf(currentId);
  timeOutId = setTimeout(() => {
    const boundHelper = nextItem.bind(this);
    boundHelper(currentIndex, keys, indicatorsForLoop);
  }, savedIndicators[currentIndex][currentId]);

  return timeOutId;
};
